export default __webpack_public_path__ + "static/media/sass.3bd84b23.svg";